import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import BackToTop from '../components/BackToTop';
import '../css/global.css';
import '../css/Training.css';

const TrainingPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="training-page">
            <Header />

            <Banner
                backgroundImage="/wp-content/uploads/2016/02/DSC_0102-1.jpg"
                title="Training"
            />

            <section className="contentwrapper clearfix">
                <div className="content clearfix">
                    <div className="breadcrumbs">
                        <a href="/">Home</a> &gt; <span>Training</span>
                    </div>

                    <h1 data-aos="fade-right">Training</h1>

                    {/* Row 1 */}
                    <div className="vc_row wpb_row vc_row-fluid">
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-right">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_text_column wpb_content_element wow fadeInLeft">
                                        <div className="wpb_wrapper">
                                            <p style={{ textAlign: "justify" }} data-aos="fade-up" data-aos-delay="100">Colombo Dockyard recognizes that training and development play an integral part in skill and knowledge development in our endeavor to create a learning culture within our organization.</p>
                                            <p style={{ textAlign: "justify" }} data-aos="fade-up" data-aos-delay="150">We actively support and encourage this knowledge gathering culture, matching individual aspirations with the Company vision and mission, aligning training and development initiatives to gain optimum results.</p>
                                            <p style={{ textAlign: "justify" }} data-aos="fade-up" data-aos-delay="200">We also encourage those who pursue professional and higher education initiatives complementing these with state of the art training facilities that helps create a team that is knowledgeable and competent, excelling in an adaptive business culture.</p>
                                            <p style={{ textAlign: "justify" }} data-aos="fade-up" data-aos-delay="250">Colombo Dockyard maintains a fully equipped training centre (Knowledge centre) for industrial, technical, and managerial training which also coordinates a wide range of training programs, seminars, workshops and other awareness programs.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-left">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_single_image wpb_content_element vc_align_left wow fadeInRight">
                                        <figure className="wpb_wrapper vc_figure">
                                            <div className="vc_single_image-wrapper vc_box_border_grey">
                                                <img
                                                    width="1200"
                                                    height="797"
                                                    src="/wp-content/uploads/2016/02/DSC_0106.jpg"
                                                    className="vc_single_image-img"
                                                    alt="Training session"
                                                />
                                            </div>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Row 2 */}
                    <div className="vc_row wpb_row vc_row-fluid" style={{ marginTop: "40px" }}>
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-right">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_single_image wpb_content_element vc_align_left wow fadeInLeft">
                                        <figure className="wpb_wrapper vc_figure">
                                            <div className="vc_single_image-wrapper vc_box_border_grey">
                                                <img
                                                    width="1200"
                                                    height="797"
                                                    src="/wp-content/uploads/2016/02/DSC_0119.jpg"
                                                    className="vc_single_image-img"
                                                    alt="Practical training"
                                                />
                                            </div>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-left">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_text_column wpb_content_element wow fadeInRight">
                                        <div className="wpb_wrapper">
                                            <p style={{ textAlign: "justify" }} data-aos="fade-up" data-aos-delay="100">The training center is registered at TVEC according to Clause No.14 of the Tertiary and and Vocational Education Act No. 20 of 1990.</p>
                                            <p style={{ textAlign: "justify" }} data-aos="fade-up" data-aos-delay="150">The accreditation of the current training programs and the establishment of the QMS required by TVEC will enable the training centre to be upgraded to a Grade A+ Training Centre.</p>
                                            <p style={{ textAlign: "justify" }} data-aos="fade-up" data-aos-delay="200">The Training centre operates under the Dept of Human Resource Development, provides facilities for training and skills development programs for all employees from welders to engineers and managers.</p>
                                            <p style={{ textAlign: "justify" }} data-aos="fade-up" data-aos-delay="250">We use the expertise of engineers, managers and training coordinators based within the Company as well as external sources as resource persons at the Training centre.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <BackToTop />
        </div>
    );
};

export default TrainingPage;
